import { Instance, types } from "mobx-state-tree";
import AiGateSectionOne, { AiGateSectionOneType } from "./AiGateSectionOne";

const AiGateModel = types.model({
  line: types.optional(AiGateSectionOne, {} as AiGateSectionOneType),
});

export type AigateModelType = Instance<typeof AiGateModel>;
export default AiGateModel;
